





































import { Component, Vue } from 'vue-property-decorator';
   @Component({ 
    })


export default class AddBank extends Vue   {

 dialog:boolean= true;

  data () {
      return {
      }
    }
 

    closeDialog(){
      this.$emit('closed');
     
    }



};
